<template>
  <div class="box">
    <swiper></swiper>
    <cont></cont>
    <share></share>
  </div>
</template>

<script>
import swiper from "./swiper"
import cont from "./cont"
import share from "./share"

export default {
  name: 'indexHome',
	components: {
    swiper,
    cont,
    share,
  },
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.box{
  background: rgba(162,219,216,0.2);
  background: linear-gradient(to bottom, #fff , rgba(162,219,216,0.2));
  min-height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue